import { render, staticRenderFns } from "./ArticleMember.vue?vue&type=template&id=40c0030c&"
import script from "./ArticleMember.vue?vue&type=script&lang=js&"
export * from "./ArticleMember.vue?vue&type=script&lang=js&"
import style0 from "./ArticleMember.vue?vue&type=style&index=0&id=40c0030c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports